import PropTypes from 'prop-types';
import { useEffect } from 'react';
import Lightbox from 'react-image-lightbox';
// @mui
import { useTheme, alpha } from '@mui/material/styles';
import { GlobalStyles, IconButton } from '@mui/material';
import Iconify from './Iconify';
import moment from 'moment';
import ModalLightbox from 'src/@/components/shared/ModalLightbox';

// ----------------------------------------------------------------------


LightboxModal.propTypes = {
  images: PropTypes.array.isRequired,
  photoIndex: PropTypes.number,
  setPhotoIndex: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default function LightboxModal({ images, photoIndex, setPhotoIndex, onClose, isOpen, onDownload, ...other }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);


  // Função para realizar o download da imagem
  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = images;
    a.download = `lais_file-${moment(new Date()).format("YYYY-MM-DD:HH:mm")}`;
    a.click();
  };

  const downloadButton = (
    <div className='flex justify-center'>
      <IconButton onClick={handleDownload}>
        <Iconify color="#fff" icon="mdi:download" width={24} height={24} />
      </IconButton>
    </div>
  );

  const toolbarButtons = [downloadButton];

  return (
    isOpen && (
      <div>
       
      <Lightbox
        mainSrc={images}
        animationDuration={160}
        enableZoom={true}
        onCloseRequest={onClose}
        toolbarButtons={toolbarButtons}
        {...other}
      />
            </div>
    )
  );
}
